<template>
    <div class="warning-messages" >
        <div class="warning-message" v-if="show" @click="dismissMessage('AdminIsBrowsingFromMobile')">
            <i class="fi fi-rr-circle-xmark close"></i>
            <div class="title" v-html="trans('general.warning_messages.admin_in_mobile')"></div>
        </div>
    </div>
</template>

<script>
import {hasAnyRole} from "../../services/RoleService";
import {getCookie, setCookie} from "../../services/CookiesManager";

export default {
    name: 'WarningMessages',
    props: {
        roles: {
            type: Array|Object,
            default: () => []
        }
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        checkIfAdminIsBrowsingFromMobile() {
            const hasCookie = getCookie('AdminIsBrowsingFromMobile');

            if (!hasCookie && window.innerWidth < 768 && hasAnyRole(['administrator'], this.roles)) {
                this.show = true;
            }
        },
        dismissMessage(messageKey) {
            setCookie(messageKey, true, 1);
            this.show = false;
        }
    },
    mounted() {
        this.checkIfAdminIsBrowsingFromMobile();
    }
}
</script>
